/* eslint-disable max-len */
import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TenantService } from 'src/app/services/api/tenant.service';
import { translate } from '@jsverse/transloco';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrService } from 'ngx-toastr';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { ClipboardService } from 'ngx-clipboard';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Attributes, Datazone, Permissions } from 'src/app/models/principal/permission';
import { Router } from '@angular/router';
import { CustomToastrService } from 'src/app/services/util/toastr.service';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_LIVE,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
    selector: 'app-subscription-tenant',
    templateUrl: './subscription-tenant.component.html',
    styleUrls: ['./subscription-tenant.component.scss'],
    standalone: false
})
export class SubscriptionTenantComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() tenantData: any;
  @Input() accountData: any;
  @Input() tenantSubscription: any;
  @Output() loading = new EventEmitter<any>();
  data: any;
  permissionsMap: { [key: string]: boolean };
  subscriptionDataId: any;
  subscriptionIdPii: any;
  subscriptionNamePii: any;
  subDataZonePii: any;
  subscriptionIdNonPii: any;
  subscriptionNameNonPii: any;
  subDataZoneNonPii: any;
  accountIdNonProdPii: any;
  accountNameNonProdPii: any;
  accountEmailNonProdPii: any;
  accDataZoneNonProdPii: any;
  accountIdNonPii: any;
  accountNameNonPii: any;
  accountEmailNonPii: any;
  accDataZoneNonPii: any;
  accountIdProdPii: any;
  accountNameProdPii: any;
  accountEmailProdPii: any;
  accDataZoneProdPii: any;
  DeployStatusPii: boolean;
  DeployStatusNonPii: boolean;
  DeployStatusTest: boolean;
  DeployStatusNonProdPii: boolean;
  DeployStatusProdPii: boolean;
  subscriptionCount = 0;
  isLoading: boolean;
  copy = false;
  tenantDetailsData: any;
  susbscriptionData: any;
  showNoSubscription: any;
  PermissionKeys = PermissionKeys;
  SubscriptionTypes = SubscriptionTypes;
  constructor(private tenantService: TenantService, private toastrService: CustomToastrService, private router: Router, private authService: AuthService, public sidenavService: SidenavService,
    public dateTimeFormatService: DateTimeFormatService, private dialog: MatDialog, private clipboardApi: ClipboardService, private permissionsService: PermissionsService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.loadData();
  }

  loadData(): void {
    this.isLoading = true;
    this.accountIdProdPii = '';
    this.accountIdNonPii = '';
    this.accountIdNonProdPii = '';
    this.subscriptionIdPii = '';
    this.subscriptionIdNonPii = '';
    this.DeployStatusNonPii = false;
    this.DeployStatusTest = false;
    this.DeployStatusPii = false;
    this.DeployStatusNonProdPii = false;
    this.DeployStatusProdPii = false;
    this.susbscriptionData = [];
    this.accountData?.forEach(item => {
      if(item?.azureDetails) {
        if(item?.dataZone === SubscriptionTypes.PII) {
          this.subscriptionIdPii = item?.azureDetails?.subscriptionId;
          this.subscriptionNamePii = item?.azureDetails?.subscriptionName;
          this.subDataZonePii = item?.dataZone;
        } else {
          this.subscriptionIdNonPii = item?.azureDetails?.subscriptionId;
          this.subscriptionNameNonPii = item?.azureDetails?.subscriptionName;
          this.subDataZoneNonPii = item?.dataZone;
        }
      }
      if(item?.awsDetails) {
        if(item?.dataZone === SubscriptionTypes.NONPII) {
          this.accountIdNonPii = item?.awsDetails?.accountId;
          this.accountNameNonPii = item?.awsDetails?.accountName;
          this.accountEmailNonPii = item?.awsDetails?.accountEmail;
          this.accDataZoneNonPii = item?.dataZone;
          this.subscriptionCount = this.subscriptionCount + 1;
        } else if(item?.dataZone === SubscriptionTypes.AWS_NON_PROD_PII){
          this.accountIdNonProdPii = item?.awsDetails?.accountId;
          this.accountNameNonProdPii = item?.awsDetails?.accountName;
          this.accountEmailNonProdPii = item?.awsDetails?.accountEmail;
          this.accDataZoneNonProdPii = item?.dataZone;
          this.subscriptionCount = this.subscriptionCount + 1;
        } else if(item?.dataZone === SubscriptionTypes.AWS_PROD_PII){
          this.accountIdProdPii = item?.awsDetails?.accountId;
          this.accountNameProdPii = item?.awsDetails?.accountName;
          this.accountEmailProdPii = item?.awsDetails?.accountEmail;
          this.accDataZoneProdPii = item?.dataZone;
          this.subscriptionCount = this.subscriptionCount + 1;
        }
      }
    });
  }

  onClickAddSubscription(data): void {
    let message;
    if (this.tenantData?.cloudProvider === 'Azure' || this.tenantData?.targetCloud === 'Azure') {
      if (data === SubscriptionTypes.PII) {
        message = translate('TENANT_DETAILS.SUBSCRIPTION_PROD');
      } else if (data === SubscriptionTypes.NONPII) {
        message = translate('TENANT_DETAILS.SUBSCRIPTION_NON_PII');
      }
    } else {
      if (data === SubscriptionTypes.NONPII) {
        message = translate('TENANT_DETAILS.SUBSCRIPTION_NON_PII');
      } else if (data === SubscriptionTypes.AWS_NON_PROD_PII) {
        message = translate('TENANT_DETAILS.SUBSCRIPTION_PII_NONPROD');
      } else if (data === SubscriptionTypes.AWS_PROD_PII) {
        message = translate('TENANT_DETAILS.SUBSCRIPTION_PII_PROD');
      }
    }
    if (message) {
      this.callDialog(message, data);
    }
  }

  callDialog(message, data): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('TENANT_DETAILS.ADD_SUBSCRIPTION'),
        message,
        confirmButtonText: translate('BUTTONS.SUBMIT')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if(confirm) {
        if (this.tenantData?.cloudProvider === 'Azure' || this.tenantData?.targetCloud === 'Azure') {
        if(data === SubscriptionTypes.PII) {
        this.DeployStatusPii = true;
        this.accountDetails(data);
        } else if(data === SubscriptionTypes.NONPII) {
          this.DeployStatusTest = true;
          this.accountDetails(data);
        }
      } else {
         if(data === SubscriptionTypes.NONPII) {
          this.DeployStatusNonPii = true;
          this.accountDetails(data);
        } else if(data === SubscriptionTypes.AWS_NON_PROD_PII) {
          this.DeployStatusNonProdPii = true;
          this.accountDetails(data);
        } else if(data === SubscriptionTypes.AWS_PROD_PII) {
          this.DeployStatusProdPii = true;
          this.accountDetails(data);
        }
      }
    }
    });
  }

  openUrl(id): void {
    const url = `https://portal.azure.com/#@temenosgroup.onmicrosoft.com/resource/subscriptions/${id}`;
    window.open(url, '_blank');
  }

  openSubscription(): void {
    if(this.tenantData.tenantId) {
      localStorage.setItem('filteredTenantSubscription', this.tenantData.tenantId);
    }
    this.router.navigate(['/',this.authService.principal.provider,'subscription']);
   }

  accountDetails(data): any {
    this.tenantService.postTenantAccountDetails(this.tenantData.tenantId, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(test => {
        this.pollForAccountDetails(data);
      },
      (error) => {
        this.accountDetailsResponse(data);
        this.isLoading = false;
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('ERROR_DIALOG.ACCOUNT_CREATION_FAILED'),
            description: errorMessage
          }
        });
      });
  }

  private pollForAccountDetails(data, retries = 15, delay = 2000): void {
    let attempt = 0;
    const tryFetch = () => {
      this.isLoading = true;
      this.tenantService.getTenantAccountDetails(this.tenantData.tenantId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((respData:any) => {
            if (respData && respData.length > 0 && this.accountData.length < respData.length) {
              this.accountData = respData;
              this.showNoSubscription = false;
              this.isLoading = false;
              this.loadData();
              this.accountDetailsResponse(data);
            } else if (attempt < retries) {
              attempt++;
              setTimeout(tryFetch, delay);
            } else {
              this.setNoSubscriptionFallback();
            }
          },
          () => {
            if (attempt < retries) {
              attempt++;
              setTimeout(tryFetch, delay);
            } else {
              this.setNoSubscriptionFallback();
            }
          }
        );
    };
    tryFetch();
  }
  
  private setNoSubscriptionFallback(): void {
    this.showNoSubscription = true;
    this.isLoading = false;
    setTimeout(() => {
      this.toastrService.errMessage(translate('SERVICE.INTERNAL_SERVER_ERROR'));
    }, 500);
  }
  

  accountDetailsResponse(data): void {
    if (this.tenantData?.cloudProvider === 'Azure' || this.tenantData?.targetCloud === 'Azure') {
      if(data === SubscriptionTypes.PII) {
        this.DeployStatusPii = false;
      } else if(data === SubscriptionTypes.NONPII) {
        this.DeployStatusTest = false;
      }
    } else {
      if(data === SubscriptionTypes.NONPII) {
        this.DeployStatusNonPii = false;
      } else if(data === SubscriptionTypes.AWS_NON_PROD_PII) {
        this.DeployStatusNonProdPii = false;
      } else if(data === SubscriptionTypes.AWS_PROD_PII) {
        this.DeployStatusProdPii = false;
      }
    }
  }

  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }
}

